export const formatCurrency = (num: number, minimumFractionDigits = 2, currency = 'INR') => {
    const locale = currency === 'INR' ? 'en-IN' : 'en-US';
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits,
    }).format(num);
  }